import React from 'react';
import Component from './Component';
import {Checkbox as BaseInput} from 'reactis-forms';
import classNames from 'classnames'
import Glyphicon from './Glyphicon';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

export default class Checkbox extends React.Component {

	getError() {
		return this.props.error && this.props.error[0];
	}

	renderInputGroup(children) {

		const tooltip = this.props.help ? <Tooltip id={this.props.help}>{this.props.help}</Tooltip> : null;
		const help = this.props.help ? <OverlayTrigger key="help" placement='top' overlay={tooltip}>
			<span className="fa fa-question-circle position-right" style={{top: -1}} />
		</OverlayTrigger> : null;

		return help ? (
			<div key="group">
				{children}
				{help}
			</div>
		) : children;
	}

	renderWrapper(children) {

		const classes = {
			'has-error': this.getError()
		};

		return <span className={classNames(classes, this.props.wrapperClassName)} key="wrapper">
				{children}
			</span>
	}

	renderLabel(children) {
		let classes = {
			'control-label': false
		};
		classes[this.props.labelClassName] = this.props.labelClassName;

		return this.props.label ? (
			<label htmlFor={this.props.id} className={classNames(classes)} key="label">
				{children}
				{this.props.label}
			</label>
		) : children;
	}

	renderInput() {
		return <BaseInput {...this.props} className={this.props.className} key="input"/>;
	}

	renderError() {
		const error = this.getError();
		return error ? (
			<span className="error-block" key="error">{error}</span>
		) : null;
	}

	render() {
		return (
			this.renderWrapper([
				this.renderInputGroup(
					this.renderInput()
				),
				this.renderError()
			])
		);
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/Checkbox.js